var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 8 12",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4e6294",
    d: "M1.162 6.391h1.316v5.415c0 .107.086.194.193.194h2.23a.194.194 0 00.194-.194v-5.39h1.512a.194.194 0 00.193-.17l.23-1.994a.194.194 0 00-.193-.216H5.095v-1.25c0-.377.203-.567.603-.567h1.139a.194.194 0 00.194-.194V.195a.194.194 0 00-.194-.194h-1.57L5.196 0c-.273 0-1.22.053-1.967.741-.828.763-.713 1.675-.686 1.834v1.46h-1.38a.194.194 0 00-.194.194v1.969c0 .106.086.193.193.193z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default "/_next/static/images/8fe226a2094f0a79d2423527d21ffe2c.svg";
export { ForwardRef as ReactComponent };